module.exports = __webpack_public_path__ + "img/d5b31c5b8debc7d5f022da128b5f1e19.png";